import React from 'react';
import { Link } from 'react-router-dom';
import { JournalText } from 'react-bootstrap-icons';

import { DownloadLink } from '../../../../General/DownloadLink';

import { Cell } from '../../../../../Interface/Response/Interest/AcceptationGuideData';

const AcceptationGuideCell: React.FC<Cell> = ({ label, acceptationGuideData }: Cell) => (
    <>
        {label}
        {acceptationGuideData?.acceptationGuideUrl && (
            <Link
                role="button"
                to={{ pathname: acceptationGuideData.acceptationGuideUrl }}
                target="_blank"
                rel="noreferrer"
                className="ml-1 text-primary float-right"
            >
                <JournalText />
            </Link>
        )}
        {acceptationGuideData?.documentRequestUrl && (
            <DownloadLink url={acceptationGuideData.documentRequestUrl} className="ml-1 text-primary float-right">
                <JournalText />
            </DownloadLink>
        )}
    </>
);

export default AcceptationGuideCell;
